import { all } from "redux-saga/effects";
import authWatcher from "./authentication/saga";
import locationsWatcher from "./locations/saga";
import complaintsWatcher from "./complaints/saga";
import statusWatcher from "./status/saga";

export default function* rootSaga() {
  yield all([
    authWatcher(),
    locationsWatcher(),
    complaintsWatcher(),
    statusWatcher()
  ]);
}
